export default class Submitter {

    /**
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {string} street 
     * @param {string} zip 
     * @param {string} city 
     * @param {string} topic 
     */
    constructor( firstName, lastName, street, zip, city ) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.street = street;
        this.zip = zip;
        this.city = city;
    }

    /**
     * @param {{ firstName: string, lastName: string, street: string, zip: string, city: string }} obj 
     */
    static fromObject( obj ) {
        if (obj === undefined) return obj;
        return new Submitter( obj.firstName, obj.lastName, obj.street, obj.zip, obj.city );
    }

    /** @override */
    toString() {
        return `${this.firstName} ${this.lastName}${this.street ? ", " + this.street : ""}, ${this.zip} ${this.city}`;
    }

    static get ANONYMUS() { return "Anonym"; }

}